import type { ErrorState, ID } from 'types';
import type { ColumnKey, IdErrorState } from '@features/buyer-line-items-pagination/types/id-error-state';

const EMPTY_VIEW: ErrorState = Object.freeze({}) as ErrorState;

export interface ErrorPositionViewParams {
  columnIndexByKey: Map<ColumnKey, number>;
  idErrors?: IdErrorState;
  rowIds: ID[];
}

/** Ids not on screen and keys with no column are skipped. */
export const toErrorPositionView = ({ columnIndexByKey, idErrors, rowIds }: ErrorPositionViewParams): ErrorState => {
  if (!idErrors || !Object.keys(idErrors).length) return EMPTY_VIEW;

  const view: ErrorState = {};
  rowIds.forEach((rowId, row) => {
    const columns = (idErrors[String(rowId)] ?? [])
      .map(key => columnIndexByKey.get(key))
      .filter((col): col is number => col !== undefined);
    if (columns.length) view[row] = columns;
  });

  return Object.keys(view).length ? view : EMPTY_VIEW;
};
